import client from 'src/helpers/authenticated-axios'

export default {
  list(query = null) {
    return client().get('/failed_messages', {
      params: query
    })
  }
}
